<template>
  <div class="content">
    <div class="search-panel">
      <button
        class="btn open-import-btn"
        @click="openAddContactsPopup"
      >
        Import from CSV
      </button>
      <CustomSearch
        id="keys_search_input"
        :model-value="keySearch"
        :class-component="'case'"
        placeholder="Search by contact"
        style="max-width: 250px"
        @update:modelValue="keySearch = $event"
        @filter="getContactsByFilter"
      />
    </div>
    <div class="holder-table">
      <table>
        <TableHeader>
          <tr>
            <th class="custom-checkbox-group" style="width: 60px;">
              <div class="checkbox-wrap">
                <input
                  :id="'checkAll_processing'"
                  v-model="checkAll"
                  class="input-checkbox"
                  type="checkbox"
                >
                <label :for="'checkAll_processing'" class="label-checkbox">
                  <span>{{ ' ' }}</span>
                </label>
                <span
                  class="checkbox-unselect"
                  @click="unselectAll"
                >{{ checkAll || checkSome.length >= 1 ? 'Unselect All' : '' }}</span>
              </div>
            </th>
            <th style="width: 180px">
              <div
                id="sort_by_group"
                class="table-header-box"
                :class="{
                  'sort-active': sortBy === 'groupName',
                  'sorted-desc': order === DESC,
                }"
                @click="sortedBy('groupName')"
              >
                <CaseIcon />
                <span class="header-table-text">Contact group</span>
                <arrowDown class="arrow" />
              </div>
            </th>
            <th style="width: 90px">
              <div class="table-header-box">
                <span class="header-table-text">Country code</span>
              </div>
            </th>
            <th style="width: 150px">
              <div class="table-header-box">
                <svg
                  width="19"
                  height="18"
                  viewBox="0 0 19 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_26960_97221)">
                    <path
                      d="M17.9306 13.2102L15.4187 10.6982C14.5216 9.80111 12.9964 10.16 12.6376 11.3262C12.3685 12.1337 11.4713 12.5822 10.6639 12.4028C8.86967 11.9542 6.44743 9.62168 5.99886 7.73772C5.72972 6.93027 6.268 6.03314 7.07541 5.76404C8.24168 5.40519 8.60053 3.88007 7.7034 2.98295L5.19145 0.470991C4.47375 -0.156997 3.3972 -0.156997 2.76921 0.470991L1.06467 2.17553C-0.639873 3.96978 1.24409 8.72455 5.46059 12.941C9.67708 17.1575 14.4319 19.1313 16.2261 17.337L17.9306 15.6324C18.5587 14.9147 18.5587 13.8382 17.9306 13.2102Z"
                      fill="#D7DCE6"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_26960_97221">
                      <rect
                        width="18"
                        height="18"
                        fill="white"
                        transform="translate(0.420898)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <span class="header-table-text">Phone Number</span>
              </div>
            </th>
            <th>
              <div class="table-header-box">
                <EmailIcon />
                <span class="header-table-text">Email</span>
              </div>
            </th>
            <th>
              <div class="table-header-box">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_26960_62240)">
                    <path
                      d="M5.20215 10.0625C5.06125 10.0625 4.92613 10.0065 4.8265 9.9069C4.72687 9.80727 4.6709 9.67215 4.6709 9.53125C4.6709 9.39035 4.72687 9.25523 4.8265 9.1556C4.92613 9.05597 5.06125 9 5.20215 9H12.6396C12.7805 9 12.9157 9.05597 13.0153 9.1556C13.1149 9.25523 13.1709 9.39035 13.1709 9.53125C13.1709 9.67215 13.1149 9.80727 13.0153 9.9069C12.9157 10.0065 12.7805 10.0625 12.6396 10.0625H5.20215Z"
                      fill="#D7DCE6"
                    />
                    <path
                      d="M4.6709 11.6562C4.6709 11.5154 4.72687 11.3802 4.8265 11.2806C4.92613 11.181 5.06125 11.125 5.20215 11.125H12.6396C12.7805 11.125 12.9157 11.181 13.0153 11.2806C13.1149 11.3802 13.1709 11.5154 13.1709 11.6562C13.1709 11.7971 13.1149 11.9323 13.0153 12.0319C12.9157 12.1315 12.7805 12.1875 12.6396 12.1875H5.20215C5.06125 12.1875 4.92613 12.1315 4.8265 12.0319C4.72687 11.9323 4.6709 11.7971 4.6709 11.6562Z"
                      fill="#D7DCE6"
                    />
                    <path
                      d="M5.20215 14.3125C5.06125 14.3125 4.92613 14.2565 4.8265 14.1569C4.72687 14.0573 4.6709 13.9221 4.6709 13.7812C4.6709 13.6404 4.72687 13.5052 4.8265 13.4056C4.92613 13.306 5.06125 13.25 5.20215 13.25H9.45215C9.59304 13.25 9.72817 13.306 9.8278 13.4056C9.92743 13.5052 9.9834 13.6404 9.9834 13.7812C9.9834 13.9221 9.92743 14.0573 9.8278 14.1569C9.72817 14.2565 9.59304 14.3125 9.45215 14.3125H5.20215Z"
                      fill="#D7DCE6"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.2947 0.5H4.6709C4.10731 0.5 3.56681 0.723883 3.1683 1.1224C2.76978 1.52091 2.5459 2.06141 2.5459 2.625V15.375C2.5459 15.9386 2.76978 16.4791 3.1683 16.8776C3.56681 17.2761 4.10731 17.5 4.6709 17.5H13.1709C13.7345 17.5 14.275 17.2761 14.6735 16.8776C15.072 16.4791 15.2959 15.9386 15.2959 15.375V5.50119C15.2958 5.21942 15.1839 4.94921 14.9846 4.75L11.0459 0.811313C10.8467 0.612041 10.5765 0.50006 10.2947 0.5ZM10.5146 2.09375V4.21875C10.5146 4.50054 10.6266 4.77079 10.8258 4.97005C11.0251 5.16931 11.2954 5.28125 11.5771 5.28125H13.7021L10.5146 2.09375ZM4.8265 9.9069C4.92613 10.0065 5.06125 10.0625 5.20215 10.0625H12.6396C12.7805 10.0625 12.9157 10.0065 13.0153 9.9069C13.1149 9.80727 13.1709 9.67215 13.1709 9.53125C13.1709 9.39035 13.1149 9.25523 13.0153 9.1556C12.9157 9.05597 12.7805 9 12.6396 9H5.20215C5.06125 9 4.92613 9.05597 4.8265 9.1556C4.72687 9.25523 4.6709 9.39035 4.6709 9.53125C4.6709 9.67215 4.72687 9.80727 4.8265 9.9069ZM4.8265 11.2806C4.72687 11.3802 4.6709 11.5154 4.6709 11.6562C4.6709 11.7971 4.72687 11.9323 4.8265 12.0319C4.92613 12.1315 5.06125 12.1875 5.20215 12.1875H12.6396C12.7805 12.1875 12.9157 12.1315 13.0153 12.0319C13.1149 11.9323 13.1709 11.7971 13.1709 11.6562C13.1709 11.5154 13.1149 11.3802 13.0153 11.2806C12.9157 11.181 12.7805 11.125 12.6396 11.125H5.20215C5.06125 11.125 4.92613 11.181 4.8265 11.2806ZM4.8265 14.1569C4.92613 14.2565 5.06125 14.3125 5.20215 14.3125H9.45215C9.59304 14.3125 9.72817 14.2565 9.8278 14.1569C9.92743 14.0573 9.9834 13.9221 9.9834 13.7812C9.9834 13.6404 9.92743 13.5052 9.8278 13.4056C9.72817 13.306 9.59304 13.25 9.45215 13.25H5.20215C5.06125 13.25 4.92613 13.306 4.8265 13.4056C4.72687 13.5052 4.6709 13.6404 4.6709 13.7812C4.6709 13.9221 4.72687 14.0573 4.8265 14.1569Z"
                      fill="#D7DCE6"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_26960_62240">
                      <rect
                        width="17"
                        height="17"
                        fill="white"
                        transform="translate(0.420898 0.5)"
                      />
                    </clipPath>
                  </defs>
                </svg>
                <span class="header-table-text">Notes</span>
              </div>
            </th>
            <th style="width: 70px;" />
            <th style="width: 30px;" />
          </tr>
        </TableHeader>
        <div v-if="checkAll || checkSome.length >= 1" class="active-header">
          <div
            class="custom-checkbox-group"
            :style="{ width: checkAll || checkSome.length > 1 ? '170px' : '60px' }"
          >
            <div class="checkbox-wrap">
              <input
                :id="'checkAll_processing'"
                v-model="checkAll"
                class="input-checkbox"
                type="checkbox"
              >
              <label :for="'checkAll_processing'" class="label-checkbox">
                <span>{{ ' ' }}</span>
              </label>
              <span
                class="checkbox-unselect"
                @click="unselectAll"
              >{{ checkAll || checkSome.length >= 1 ? 'Unselect All' : '' }}</span>
            </div>
          </div>
          <div class="btn-wrapper">
            <button class="btn btn-copy" @click="copySelected">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.25 3H8.25C8.05109 3 7.86032 3.07902 7.71967 3.21967C7.57902 3.36032 7.5 3.55109 7.5 3.75V7.5H3.75C3.55109 7.5 3.36032 7.57902 3.21967 7.71967C3.07902 7.86032 3 8.05109 3 8.25V20.25C3 20.4489 3.07902 20.6397 3.21967 20.7803C3.36032 20.921 3.55109 21 3.75 21H15.75C15.9489 21 16.1397 20.921 16.2803 20.7803C16.421 20.6397 16.5 20.4489 16.5 20.25V16.5H20.25C20.4489 16.5 20.6397 16.421 20.7803 16.2803C20.921 16.1397 21 15.9489 21 15.75V3.75C21 3.55109 20.921 3.36032 20.7803 3.21967C20.6397 3.07902 20.4489 3 20.25 3ZM15 19.5H4.5V9H15V19.5ZM19.5 15H16.5V8.25C16.5 8.05109 16.421 7.86032 16.2803 7.71967C16.1397 7.57902 15.9489 7.5 15.75 7.5H9V4.5H19.5V15Z"
                  fill="#696F79"
                />
              </svg>
              Copy Selected
            </button>
            <button class="btn btn-delete" @click="confirmDeleteGroups">
              <svg
                width="23"
                height="24"
                viewBox="0 0 23 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.375 5.96154H4.625C4.45924 5.96154 4.30027 6.02637 4.18306 6.14178C4.06585 6.25719 4 6.41371 4 6.57692C4 6.74013 4.06585 6.89666 4.18306 7.01207C4.30027 7.12747 4.45924 7.19231 4.625 7.19231H5.25V18.2692C5.25 18.5957 5.3817 18.9087 5.61612 19.1395C5.85054 19.3703 6.16848 19.5 6.5 19.5H16.5C16.8315 19.5 17.1495 19.3703 17.3839 19.1395C17.6183 18.9087 17.75 18.5957 17.75 18.2692V7.19231H18.375C18.5408 7.19231 18.6997 7.12747 18.8169 7.01207C18.9342 6.89666 19 6.74013 19 6.57692C19 6.41371 18.9342 6.25719 18.8169 6.14178C18.6997 6.02637 18.5408 5.96154 18.375 5.96154ZM16.5 18.2692H6.5V7.19231H16.5V18.2692ZM7.75 4.11538C7.75 3.95217 7.81585 3.79565 7.93306 3.68024C8.05027 3.56483 8.20924 3.5 8.375 3.5H14.625C14.7908 3.5 14.9497 3.56483 15.0669 3.68024C15.1842 3.79565 15.25 3.95217 15.25 4.11538C15.25 4.27859 15.1842 4.43512 15.0669 4.55053C14.9497 4.66593 14.7908 4.73077 14.625 4.73077H8.375C8.20924 4.73077 8.05027 4.66593 7.93306 4.55053C7.81585 4.43512 7.75 4.27859 7.75 4.11538Z"
                  fill="#F1105F"
                />
              </svg>
              Delete Selected
            </button>
          </div>
        </div>
        <Loader v-if="loadFlag" :load-flag="loadFlag" />
        <template v-else>
          <InscopeItem
            :inscope-data="users"
            @groupUpdated="updateGroup"
            @saveNewContact="saveNewContact"
            @deleteContact="openDeleteContactPopup"
          />
          <p
            v-if="!users.length"
            class="no-found"
          >
            No data
          </p>
        </template>
      </table>
      <pagination
        v-if="users.length && totalPages !== 1"
        v-model="page"
        :total-pages="totalPages"
        :link-gen="paginationLinkGen"
        @input="onPageChange"
      />
    </div>
    <AddContactsPopup
      ref="addContactPopup"
      @uploadData="uploadInscopeInfo"
    />
    <SuccessPopup
      ref="generalSuccessPopup"
      :text="popupText"
    />
    <SmallAlert
      ref="smallAlert"
      :message-text="'Changes saved'"
    />
    <SmallAlert
      ref="copyAlert"
      :message-text="'Data copied'"
    />
    <InfoDialog
      ref="deleteGroupsDialog"
      :title="infoDialogData.dialogTitle"
      :text="infoDialogData.dialogText"
      :confirm-btn-text="infoDialogData.confirmBtnText"
      :cancel-btn-text="infoDialogData.cancelBtnText"
      @onConfirm="deleteSelected"
    />
    <InfoDialog
      ref="deleteContactDialog"
      :title="infoDialogData.dialogTitle"
      :text="infoDialogData.dialogText"
      :confirm-btn-text="infoDialogData.confirmBtnText"
      :cancel-btn-text="infoDialogData.cancelBtnText"
      @onConfirm="handleDeleteContact"
    />
    <AlertErrorMsg
      ref="alert"
      :title="errorMessage"
      class="page-alert-error"
    />
  </div>
</template>

<script>
import {validationMixin} from 'vuelidate';
import CustomSearch from '@/components/inputs/CustomSearch.vue';
import ArrowDown from '@/components/icons/ArrowDown.vue';
import Loader from '@/components/loader/Loader.vue';
import CaseIcon from '@/components/icons/CaseIcon.vue';
import TableHeader from '@/components/table/TableHeader.vue';
import {ASC, DESC} from '@/constants/const';
import checkAll from '@/mixins/checkAll';
import EmailIcon from '@/components/icons/EmailIcon.vue';
import AddInscopeContactsPopup from '@/components/popups/AddInscopeContactsPopup.vue';
import SuccessPopup from '@/components/popups/SuccessPopup.vue';
import errorHandler from '@/mixins/errorHandler';
import AlertErrorMsg from '@/components/profile/AlertErrorMsg.vue';
import InscopeItem from '@/components/cases/case-settings/InscopeItem.vue';
import SmallAlert from '@/components/alerts/SmallAlert.vue';
import InfoDialog from '@/components/popups/InfoDialog.vue';
import {createDeleteDialog} from '@/constants/infoDialogData';
import Pagination from '@/components/common/Pagination.vue';

export default {
  name: 'CaseSettingsContacts',
  components: {
    InfoDialog,
    SmallAlert,
    InscopeItem,
    AlertErrorMsg,
    SuccessPopup,
    AddContactsPopup: AddInscopeContactsPopup,
    EmailIcon,
    TableHeader,
    CaseIcon,
    Loader,
    ArrowDown,
    CustomSearch,
    Pagination,
  },
  mixins: [checkAll, validationMixin, errorHandler],
  data() {
    return {
      page: 1,
      size: 10,
      totalPages: 1,
      DESC,
      caseId: this.$route.params.slug,
      keySearch: '',
      loadFlag: false,
      sortBy: 'groupName',
      order: DESC,
      users: [],
      popupText: 'New contacts were added',
      infoDialogData: {
        dialogTitle: '',
        dialogText: '',
        confirmBtnText: '',
        cancelBtnText: '',
      },
    };
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    this.page = +(urlParams.get('page') || 1);
    this.getInscopeContacts();
  },
  methods: {
    getContactsByFilter() {
      this.page = 1;
      this.getInscopeContacts();
    },
    sortedBy() {
      this.order = this.order === DESC ? ASC : DESC;
      this.getInscopeContacts();
    },
    unselectAll() {
      this.users.forEach(item => {
        item.isActive = false;
      });
    },
    openAddContactsPopup() {
      this.$refs.addContactPopup.openPopups();
    },
    uploadInscopeInfo(jsonData) {
      this.$load(async () => {
        const inscopeContacts = jsonData.map(item => {
          return {
            name: item.group_name,
            contacts: item.contacts
          };
        });
        await this.$api.inscope.createOrUpdateGroup(this.$route.params.slug, inscopeContacts);
        this.$refs.addContactPopup.closePopups();
        this.popupText = 'New contacts were added';
        this.$refs.generalSuccessPopup.openPopup();
        this.getInscopeContacts();
      }, (error) => {
        this.handleResponseError(error);
      });
    },
    getInscopeContacts() {
      this.$load(async () => {
        const response = await this.$api.inscope.getInScopeGroupAndContacts(
          this.$route.params.slug,
          this.page,
          this.size,
          this.keySearch,
          this.order,
        );
        this.users = response.data.body.content.map(item => {
          return {
            ...item,
            isActive: false,
          };
        });
        this.totalPages = response.data.body.totalPages;
      }, (error) => {
        this.handleResponseError(error);
      });
    },
    updateGroup(groupItem) {
      this.$load(async () => {
        await this.$api.inscope.editInScopeGroup(groupItem.id, groupItem);
        this.getInscopeContacts();
        this.$refs.smallAlert.showAlert();
      }, (error) => {
        this.handleResponseError(error);
      });
    },

    saveNewContact(newContactData) {
      this.$load(async () => {
        await this.$api.inscope.createOrUpdateGroup(this.$route.params.slug, [newContactData]);
        this.popupText = 'New contact was added';
        this.$refs.generalSuccessPopup.openPopup();
        this.getInscopeContacts();
      }, (error) => {
        this.handleResponseError(error);
      });
    },

    copySelected() {
      const selectedGroups = this.users.filter(user => user.isActive);
      const formattedText = selectedGroups.map(group => {
        return `Group: ${group.name}\n`
          + group.contacts.map(contact => {
            return `Country code: ${contact.countryCode}\n`
              + `Phone: ${contact.phoneNumber}\n`
              + `Email: ${contact.email}\n`
              + `Notes: ${contact.note}\n`;
          }).join('\n');
      }).join('\n');

      navigator.clipboard.writeText(formattedText).then(() => {
        this.$refs.copyAlert.showAlert();
      });

      this.unselectAll();
    },
    confirmDeleteGroups() {
      this.infoDialogData = createDeleteDialog('groups');
      this.$refs.deleteGroupsDialog.openPopup();
    },
    deleteSelected() {
      const selectedGroups = this.users.filter(user => user.isActive);
      this.$load(async () => {
        await this.$api.inscope.deleteInScopeGroup(selectedGroups.map(group => group.id));
        this.getInscopeContacts();
      });
      this.popupText = 'Selected groups were deleted';
      this.$refs.generalSuccessPopup.openPopup();
    },
    openDeleteContactPopup(payload) {
      this.infoDialogData = createDeleteDialog('contact');
      this.$refs.deleteContactDialog.openPopup(payload);
    },
    handleDeleteContact({item, index}) {
      if (item.contacts && item.contacts.length > 0) {
        if (item.contacts.length === 1) {
          this.$load(async () => {
            await this.$api.inscope.deleteInScopeGroup([item.id]);
            this.getInscopeContacts();
            this.popupText = 'Contact was deleted';
            this.$refs.generalSuccessPopup.openPopup();
          }, (error) => {
            this.handleResponseError(error);
          });
        } else {
          const updatedItem = {...item};
          updatedItem.contacts = [...item.contacts];
          updatedItem.contacts.splice(index, 1);

          this.$load(async () => {
            await this.$api.inscope.editInScopeGroup(item.id, updatedItem);
            this.getInscopeContacts();
            this.popupText = 'Contact was deleted';
            this.$refs.generalSuccessPopup.openPopup();
          }, (error) => {
            this.handleResponseError(error);
          });
        }
      }
    },
    paginationLinkGen(pageNum) {
      return {
        path: this.$route.path,
        query: {...this.$route.query, page: pageNum}
      };
    },
    onPageChange(page) {
      if (page === this.page) return;

      this.page = page;

      const url = new URL(window.location);
      url.searchParams.set('page', page);
      window.history.replaceState({}, '', url);

      this.getInscopeContacts();
    }
  }
};
</script>

<style scoped>
.search-panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.holder-table {
  position: relative;
}

.active-header {
  display: flex;
  align-items: center;
  position: absolute;
  top: 26px;
  left: 0;
  z-index: 2;
  padding: 22px 18px 20px 18px;
  justify-content: space-between;
  background-color: var(--accent-color);
  width: 100%;
}

.holder-table {
  padding: 24px 0;
}

.checkbox-wrap .checkbox-unselect {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  color: #FFFFFF;
  text-transform: initial;
  cursor: pointer;
  padding: 2px 0 0;
}

.dialog-message-title {
  font-style: normal;
  font-weight: bold;
  font-size: 30px;
  line-height: 36px;
  color: #292B2F;
  text-align: center;
  margin: 0;
  display: block;
  width: 100%;
  margin-top: 25px;
}

.dialog-message-description {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  text-align: center;
  color: #696F79;
  display: block;
  margin-top: 20px;
}

.btn-wrapper {
  display: flex;
  gap: 15px;
  align-items: center;
  width: 370px;
}

.btn-copy, .btn-delete {
  font-weight: 500;
  font-size: 12px;
  line-height: 120%;
  text-align: center;
  vertical-align: middle;
  display: flex;
  align-items: center;
  gap: 15px;
  transition: background-color 0.3s ease;
}

.btn-copy {
  color: var(--secondary-text-color);
  background-color: var(--white-color);
}

.btn-copy:hover {
  color: var(--secondary-text-color);
  background-color: var(--white-color);
}

.btn-copy svg path {
  fill: var(--secondary-text-color);
}

.btn-copy:hover svg path {
  fill: var(--secondary-text-color);
}

.btn-delete {
  color: var(--error-color);
  background-color: var(--white-color);
}

.btn-delete:hover {
  color: var(--error-color);
  background-color: var(--white-color);
}

.btn-delete svg path {
  fill: var(--error-color);
}

.btn-delete:hover svg path {
  fill: var(--error-color);
}
</style>
